import { FLAG_DRUG_REFERENCE_TOOL } from '../answer-blocks/drugInteractionWarning';
import { isVisualDxAgentToolName } from './VisualDxAgentToolBlock';

interface EvidenceChildVisibilityItem {
  kind: string;
  name?: string;
}

export const MEDICAL_CALCULATOR_TOOL = 'medical_calculator';

export const isSuppressedEvidenceChildTool = (
  name: string,
  residualCapabilitiesEnabled: boolean
): boolean =>
  name === FLAG_DRUG_REFERENCE_TOOL ||
  name === 'search_medical_calculators' ||
  (!residualCapabilitiesEnabled &&
    (name === MEDICAL_CALCULATOR_TOOL || isVisualDxAgentToolName(name)));

export const findLastRenderableEvidenceChildIndex = (
  items: readonly EvidenceChildVisibilityItem[],
  residualCapabilitiesEnabled: boolean
): number =>
  items.findLastIndex(
    (item) =>
      (item.kind === 'assistant_text' || item.kind === 'tool_use') &&
      (item.kind !== 'tool_use' ||
        !item.name ||
        !isSuppressedEvidenceChildTool(item.name, residualCapabilitiesEnabled))
  );
